export default "__VITE_ASSET__DuNa3knZ__"